var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-open",attrs:{"type":"button"},on:{"click":_vm.toggleMiniCart}},[_c('img',{attrs:{"src":"/images/cart.svg","alt":"","title":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.__('minicart.button.text')))]),_vm._v(" "),_c('span',{staticClass:"counter",domProps:{"textContent":_vm._s(_vm.itemCount)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }